/**
 * Utility to join classnames, filtering out falsy values.
 */
export function cn(...classes: readonly (string | undefined | false | null)[]): string {
  return classes.filter(Boolean).join(" ");
}

/* ── Tailwind class maps ──────────────────────────────────────── */

const gapValues: Readonly<Record<number, string>> = {
  0: "gap-0",
  0.5: "gap-0.5",
  1: "gap-1",
  1.5: "gap-1.5",
  2: "gap-2",
  2.5: "gap-2.5",
  3: "gap-3",
  4: "gap-4",
  5: "gap-5",
  6: "gap-6",
  8: "gap-8",
  10: "gap-10",
  12: "gap-12",
};

const pxValues: Readonly<Record<number, string>> = {
  0: "px-0",
  1: "px-1",
  1.5: "px-1.5",
  2: "px-2",
  2.5: "px-2.5",
  3: "px-3",
  3.5: "px-3.5",
  4: "px-4",
  5: "px-5",
  6: "px-6",
  8: "px-8",
};

const pyValues: Readonly<Record<number, string>> = {
  0: "py-0",
  0.5: "py-0.5",
  1: "py-1",
  1.5: "py-1.5",
  2: "py-2",
  2.5: "py-2.5",
  3: "py-3",
  4: "py-4",
  5: "py-5",
  6: "py-6",
  8: "py-8",
};

const pValues: Readonly<Record<number, string>> = {
  0: "p-0",
  1: "p-1",
  1.5: "p-1.5",
  2: "p-2",
  3: "p-3",
  4: "p-4",
  5: "p-5",
  6: "p-6",
};

export function gapClass(value: number | undefined): string | undefined {
  return value !== undefined ? gapValues[value] : undefined;
}

export function pxClass(value: number | undefined): string | undefined {
  return value !== undefined ? pxValues[value] : undefined;
}

export function pyClass(value: number | undefined): string | undefined {
  return value !== undefined ? pyValues[value] : undefined;
}

export function pClass(value: number | undefined): string | undefined {
  return value !== undefined ? pValues[value] : undefined;
}
